export default "__VITE_ASSET__0aRX3ebS__"